import { render, staticRenderFns } from "./channe.vue?vue&type=template&id=d1869f64&scoped=true"
import script from "./channe.vue?vue&type=script&lang=js"
export * from "./channe.vue?vue&type=script&lang=js"
import style0 from "./channe.vue?vue&type=style&index=0&id=d1869f64&prod&lang=less"
import style1 from "./channe.vue?vue&type=style&index=1&id=d1869f64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1869f64",
  null
  
)

export default component.exports